import script from "./CameraDevice.vue?vue&type=script&setup=true&lang=js"
export * from "./CameraDevice.vue?vue&type=script&setup=true&lang=js"

import "./CameraDevice.vue?vue&type=style&index=0&id=6b61f781&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b61f781"]])

export default __exports__